class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
  this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);

  this.summaryToggle.setAttribute('aria-expanded', 'true');
  event.target.closest('details').setAttribute('open', true);

  this.searchInput = this.querySelector('.search__input');

  // Force focus after DOM + layout settle
  setTimeout(() => {
    if (this.searchInput) {
      this.searchInput.removeAttribute('disabled');
      this.searchInput.focus({ preventScroll: true });
    }
  }, 500);


  document.body.addEventListener('click', this.onBodyClickEvent);
  document.body.classList.add('overflow-hidden');

  trapFocus(
    this.detailsContainer.querySelector('[tabindex="-1"]'),
    this.searchInput
  );
}


  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.summaryToggle.setAttribute('aria-expanded', 'false');
    setTimeout(() => {
      this.detailsContainer.removeAttribute('open');
    }, 250);
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);
